import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "./homeStyles";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Create from "../Create/Create";
import ClaimToken from "../ClaimToken/ClaimToken";
import { useWeb3React } from "@web3-react/core";
import { backendURL } from "../../contract/constant";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function Home({setTriggerTransaction, triggerTransaction}) {
  const { account, active, connector, deactivate, library, chainId } =
    useWeb3React();
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [claims, setClaims] = useState([]);
  const [filterArray, setFilterArray] = useState([]);
  const [isApproving, setIsApproving] = React.useState(false);
  const [isClaimLoading, setIsClaimLoading] = React.useState(false);
  const [firstTimeWrongNetwork, setFirstTimeWrongNetwork] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getClaimableAssets = async (userAccount) => {
    // setIsClaimLoading(true);
    return fetch(`${backendURL}getClaims/${userAccount}`)
      .then((response) => response.json()) 
      .then((data) => {
        // console.log("filter array: ", filterArray,data.filter(items => filterArray.indexOf(items._id) === -1).reverse() )
        //   setClaims(data.filter(items => {
        //     return filterArray.indexOf(items._id) === -1}).reverse())
        setClaims(data.reverse());  
        // setIsClaimLoading(false);
        }).catch(e=>{
        // setIsClaimLoading(false);
      });
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div className={classes.body}>
      <div className={classes.yellowGradientShadow}> </div>
      <div className={classes.root}>
        <div className={classes.mainHeading}>Cross Chain Bridge</div>

        <div className={classes.mainContent}>
          <AppBar position="static" color="default" className={classes.tabs}>
            <Tabs
              value={value}
              onChange={handleChange}
              // indicatorColor="none"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
              className={classes.indicatorTab}
            >
              <Tab
                className={classes.tabLabel}
                style={{fontWeight:"bold"}}
                label="Create"
                disableRipple={true}
                {...a11yProps(0)}
              />
              <Tab
                className={classes.tabLabel}
                style={{fontWeight:"bold"}}
                label="Claim"
                disableRipple={true}
                {...a11yProps(1)}
              />
            </Tabs>
          </AppBar>
          <div
            // axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            // index={value}
            style={{paddingTop:"12px"}}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction}>
              <Create sendToClaim={setValue} setTriggerTransaction={setTriggerTransaction} triggerTransaction={triggerTransaction} isApproving={isApproving} setIsApproving={setIsApproving} claims={claims} setClaims={setClaims} getClaimableAssets={getClaimableAssets} />
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              <ClaimToken  claims={claims} setClaims={setClaims} setTriggerTransaction={setTriggerTransaction} triggerTransaction={triggerTransaction}  getClaimableAssets={getClaimableAssets} isLoading={isClaimLoading} filterArray={filterArray}
setFilterArray={setFilterArray} />
            </TabPanel>
          </div>
        </div>
      </div>
    </div>
  );
}
